import styled from "styled-components";
import { COLORS, LAYOUT } from "@/constants/styles";
import { getFontStyles } from "@/redux/cmsConfig/utils";

interface StyledMessagePreviewProps {
  activeMessage: boolean;
}

export const StyledMessagePreview = styled.button<StyledMessagePreviewProps>`
  ${({ theme }) => `
    background: ${theme.location_card.background_color};
    border: solid 1px ${theme.location_card.border_color};
    border-radius: ${theme.location_card.border_radius}px;
  `}

  border-left: solid 4px ${({ activeMessage, theme }) =>
    activeMessage
      ? theme.global.primary_active_color
      : theme.location_card.border_color};
  cursor: pointer;
  display: flex;
  overflow: hidden;
  margin-bottom: ${LAYOUT.GUTTER / 2}px;
  padding: ${LAYOUT.GUTTER}px;
  text-align: left;
  width: 35%;

  &:last-child {
    margin-bottom: 0px;
  }

  @media (max-width: 767px) {
    margin: ${LAYOUT.GUTTER / 2}px;
    padding: ${LAYOUT.GUTTER / 2}px;
    width: calc(100% - ${LAYOUT.GUTTER}px);
  }
`;

interface StyledPreviewTextProps {
  messageRead: boolean;
}

export const StyledPreviewText = styled.div<StyledPreviewTextProps>(
  ({ theme, messageRead }) => ({
    "h3, h2": {
      display: "-webkit-box",
      margin: "0 0 10px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitLineClamp: 1,
      WebkitBoxOrient: "vertical",
      ...getFontStyles(theme.location_card.secondary_font, {
        font_weight: () => (messageRead ? 400 : 900),
      }),
    },
    p: {
      display: "-webkit-box",
      margin: "0 0 10px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      ...getFontStyles(theme.location_card.font),

      "&:last-child": {
        marginBottom: "0px",
      },
    },
  })
);

interface StyledCroppedImageContainerProps {
  isUnread: boolean;
}

export const StyledCroppedImageContainer = styled.div<StyledCroppedImageContainerProps>`
  margin-right: ${LAYOUT.GUTTER}px;
  position: relative;

  ${({ isUnread, theme }) =>
    isUnread &&
    `
    &:after {
      content: '';
      width: 16px;
      height: 16px;
      background: ${theme.global.primary_active_color};
      border-radius: 50%;
      border: solid 2px ${COLORS.WHITE};
      position: absolute;
      top: -5px;
      right: -5px;
    }
  `}

  @media (max-width: 767px) {
    margin-right: ${LAYOUT.GUTTER / 2}px;
  }
`;

export const StyledCroppedImage = styled.img`
  ${({ theme }) => `
    border: 1px solid ${theme.auth_page.border_color};
    border-radius: ${theme.auth_page.border_radius}px;
  `}

  object-fit: cover;
  height: 72px;
  width: 72px;

  @media (max-width: 767px) {
    width: 48px;
    height: 48px;
  }
`;
